import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Images
import img1 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/Pay-flexibility-1.webp";
import img2 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/improve-timeclock-compliance-1-1.webp";
import img3 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/Increased engagement.webp";
import img4 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/Reduced-turnover-1.webp";
import img5 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/Financial-wellness-1.webp";
import img6 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/reduced-financial-stress-1.webp";
import img7 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/increased-motivation-1.webp";
import img8 from "../../../assets/EMP_hospitalhealthcare/HealthcareSlider/Improvied-productivity-1.webp";

export default function HealthcareSlider() {

  const cards = [
    {
      image: img1,
      title: "Pay flexibility",
      text: "Companies that offer flexible access to earned pay see the difference — 94% report a positive impact on their team's productivity.1",
    },
    {
      image: img2,
      title: "Improve timeclock compliance",
      text: "Pay flexibility supports irregular schedules, boosts timeclock compliance, and drives productivity — with 94% of companies reporting positive results after implementing  On-Demand Pay.2",
    },
    {
      image: img3,
      title: "Increased engagement",
      text: "Teams are more engaged too, with 55% of employees report picking up extra shifts each month.3",
    },
    {
      image: img4,
      title: "Improved turnover",
      text: "Healthcare employers see 43% lower average turnover rate for DailyPay enrolled users.4",
    },
    {
      image: img5,
      title: "Improved financial wellness",
      text: "100% of healthcare companies with an earned wage access solution indicated financial wellness has a positive impact on productivity.5",
    },
    {
      image: img6,
      title: "Reduced financial stress",
      text: "Financially stressed employees are nearly five times as likely to admit personal finance issues have been a distraction at work. Half (50%) of users say DailyPay helps reduce their financial stress.6",
    },
    {
      image: img7,
      title: "Increased motivation",
      text: "48% of users in healthcare, medical, or social assistance industries say having DailyPay makes them feel more motivated at work.7",
    },
    {
      image: img8,
      title: "Improved productivity",
      text: "42% of DailyPay users in healthcare, medical, or social assistance industries say they are more productive at work because they have DailyPay.8",
    },
  ];

  const visibleCards = 4;

  const [currentIndex, setCurrentIndex] = useState(0);

  // CARD WIDTH + GAP
  const slideAmount = 324;

  // NEXT
  const handleNext = () => {
    if (currentIndex < cards.length - visibleCards) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // PREV
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <section className="w-full bg-white lg:-mt-[50px] overflow-hidden">

      <div className="max-w-7xl mx-auto relative px-2">

        {/* LEFT BUTTON */}
        {currentIndex > 0 && (
          <button
            onClick={handlePrev}
            className="
              absolute
              left-[-25px]
              top-[38%]
              -translate-y-1/2
              z-20
              w-14
              h-14
              rounded-full
              bg-white
              hover:bg-[#4b0000]
                hover:text-white
              border
              shadow-md
              flex
              items-center
              justify-center
            "
          >
            <ChevronLeft size={34} />
          </button>
        )}

        {/* RIGHT BUTTON */}
        {currentIndex < cards.length - visibleCards && (
          <button
            onClick={handleNext}
            className="
              absolute
              right-[-25px]
              top-[38%]
              -translate-y-1/2
              z-20
              w-14
              h-14
              rounded-full
              bg-white
                hover:bg-[#4b0000]
                hover:text-white
              border
              shadow-md
              flex
              items-center
              justify-center
            "
          >
            <ChevronRight size={34} />
          </button>
        )}

        {/* SLIDER */}
        <div className="overflow-hidden">

          <div
            className="flex gap-6 transition-all duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * slideAmount}px)`,
            }}
          >

            {cards.map((card, index) => (
              <div
                key={index}
                className="
                  w-[300px]
                  min-w-[300px]
                  lg:h-[400px]
                  bg-[#f5f5f5]
                  rounded-[30px]
                  p-8
                  h-[520px]
                  flex-shrink-0
                "
              >

                {/* IMAGE */}
                <img
                  src={card.image}
                  alt=""
                  className="w-24 h-26 object-contain mb-8"
                />

                {/* TITLE */}
               <h2 className="text-[18px] lg:text-[20px] font-extrabold leading-tight text-black font-serif -mt-2">
  {card.title}
</h2>

                {/* TEXT */}
                <p className="mt-8 lg:mt-6 text-[16px] lg:text-[16px] leading-[1.5] lg:leading-[1.3] text-[#280303] font-[500]">
                  {card.text}
                </p>

              </div>
            ))}

          </div>

        </div>

        {/* DOTS */}
        <div className="flex justify-center items-center gap-3 mt-10">

          <div
            className={`
              w-3
              h-3
              rounded-full
              ${currentIndex <= 1 ? "bg-black" : "bg-gray-300"}
            `}
          />

          <div
            className={`
              w-3
              h-3
              rounded-full
              ${currentIndex >= 2 ? "bg-black" : "bg-gray-300"}
            `}
          />

        </div>

      </div>
      {/* FOOTNOTES */}
<div className="max-w-[1400px] mx-auto px-4 mt-8 mb-20">

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>1, 2, 5</sup> Hanover Research Study: Companies with EWA Solutions, September 2023
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>3, 7, 8</sup> DailyPay Employee Experience Research, Arizent study commissioned by DailyPay, September 2023
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>4</sup> Internal Database, March 2025
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>6</sup> DailyPay User Survey, February 2025
  </p>

</div>

    </section>
  );
}